'use client';

import { saPushEvent } from '@spot-fe/utils';
import React, { createContext, useContext, useEffect, useState, PropsWithChildren } from 'react';

interface DataVersionContextType {
  dataVersion: string | null;
}

const DataVersionContext = createContext<DataVersionContextType>({
  dataVersion: null,
});

export const useDataVersion = () => {
  const context = useContext(DataVersionContext);
  if (!context) {
    throw new Error('useDataVersion must be used within a DataVersionProvider');
  }
  return context;
};

export const DataVersionProvider: React.FC<PropsWithChildren & {
  evt: string
}> = ({ children, evt }) => {
  const [dataVersion, setDataVersion] = useState<string | null>(null);

  useEffect(() => {
    // 获取 html 标签上的 data-version 属性
    const htmlElement = document.documentElement || document.querySelector('html');
    if (htmlElement) {
      const version = htmlElement.getAttribute('data-version');
      setDataVersion(version);
      
      if (evt) {
        saPushEvent(evt, {
          spot_web_version: dataVersion,
        });
      }
    }
  }, []);

  return (
    <DataVersionContext.Provider value={{ dataVersion }}>
      {children}
    </DataVersionContext.Provider>
  );
}; 